<template>
	<div class="table-responsive">
		<table id="data-table" class="table table-bordered data-table">
			<thead>
				<tr>
					<th v-for="head in response.tbl_heads.heads" :key="head">
						{{ head }}
					</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="response.chart_type === 'pie'">
					<tr v-for="(expense, key) in response.expenses" :key="'exp' + key">
						<td
							v-if="key === 0"
							:rowspan="Object.keys(response.expenses).length"
							style="padding: 100px 20px"
						>
							<h3>{{ expense.position }}</h3>
						</td>
						<td v-else style="display: none"></td>
						<td>{{ expense.val1 }}</td>
						<td :style="checkLimit(expense ?? null)">
							{{ formatMoney(expense.total) }}
						</td>
					</tr>
				</template>
				<template v-else>
					<tr
						v-for="(expense, val, key) in response.expenses"
						:key="'ex' + key"
					>
						<td
							v-if="key === 0"
							:rowspan="Object.keys(response.expenses).length"
							:style="
								Object.keys(response.expenses).length > 1
									? 'padding: 100px 20px'
									: null
							"
						>
							<h3>{{ Object.values(expense)[key]["position"] }}</h3>
						</td>
						<td v-else style="display: none"></td>
						<td>{{ val }}</td>

						<template v-for="(head, index) in response.tbl_heads.heads">
							<td
								v-if="index > 1"
								:key="'p' + index"
								:style="checkLimit(expense[head] ? expense[head] : null)"
							>
								{{
									expense[head] ? formatMoney(expense[head]["total_cost"]) : 0
								}}
							</td>
						</template>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>
<script>
import Swal from "sweetalert2";

export default {
	props: {
		response: {
			required: true,
			type: Object,
		},
	},

	methods: {
		formatMoney(amount) {
			return new Intl.NumberFormat("en-NG", {
				style: "currency",
				currency: "NGN",
			}).format(amount);
		},

		checkLimit(expense) {
			if (!expense) {
				return;
			}

			let bgColor = null;

			if (
				expense &&
				parseFloat(expense["spend_limit"]) < parseFloat(expense["total_cost"])
			) {
				bgColor = "background:red";

				Swal.fire({
					title: "Over Spending",
					text:
						"The total expenditure has exceeded the approved spending limit of " +
						this.formatMoney(expense["spend_limit"]),
					icon: "error",
					allowOutsideClick: false,
				});
			}

			return bgColor;
		},
	},
};
</script>
